import React, { RefObject } from "react";
import { handleEnterPress } from "component-library";

export interface IActionProps extends React.AnchorHTMLAttributes<any> {
  forwardRef?: RefObject<HTMLAnchorElement>;
}

export const Action: React.FC<React.PropsWithChildren<IActionProps>> = ({
  forwardRef,
  onClick,
  tabIndex = 0,
  onKeyPress = handleEnterPress(onClick),
  children,
  ...rest
}) => {
  return (
    <a
      tabIndex={tabIndex}
      onKeyPress={onKeyPress}
      onClick={onClick}
      ref={forwardRef}
      role="button"
      {...rest}
    >
      {children}
    </a>
  );
};
